// extracted by mini-css-extract-plugin
export default {"Badge":"badges_Badge__S1Mx3","noBackground":"badges_noBackground__K0pCW"};